<template>

    <div class="brt-map-recommendModule" ref="recommendModule" v-click-outside="recomTabOutside">

        <div class="box">附近设施</div>

        <div class="box c-box"  @click="showTab ? showTab = false : showTab = true">

            <div class="wrap">
                <img :src="item.imgUrl" v-for="(item,index) in recom" v-if="index < 6">

                <div class="more-box" v-if="recom.length > 6"><i></i><i></i><i></i></div>
            </div>

        </div>


        <!--天气-->
        <div class="box r-box">
            <!--<i class="iconfont icon-fine"></i>-->
            <!--<span>13℃</span>-->
        </div>


        <!--展示-->
        <div class="box recomDetail" v-if="showTab">

            <div class="title">
                <span>一键查找附近</span>
                <i class="iconfont icon-close-02" @click="showTab = false;brtmap.guideView=true"></i>
            </div>

            <div class="item-box">

                <div :class="(recom.length % 3 == 0) ? ((index >= recom.length -3)?'box no-btm' :'box'):(recom.length % 3 == 2)?( (index >= recom.length -2) ? 'box no-btm' : 'box'):((recom.length % 3 == 1)?((index == recom.length -1)? 'box no-btm' : 'box' ):'box')" v-for="(item,index) in recom" @click="recomTab(item)">

                    <img :src="item.imgUrl">
                    <span>{{item.name}}</span>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import {directive as clickOutside} from 'v-click-outside-x';
    export default {
        name: "RecommendModule",
        directives: { clickOutside },
        data(){
            return {
                recom:[],
                showTab:false,
                recomT:'',
            }
        },

        computed:{
            ...mapState({
                brtmap:state=>state.mapStore.brtmap,
                publicFormat:state=>state.RecommendData.publicFormat,
            })
        },

        methods:{

            recomTab(item){
                this.$emit('on-result',item);
                this.$nextTick(()=>{
                    this.brtmap.guideView = true;
                })
            },

            recomTabOutside(){
                if(this.showTab){
                    this.showTab = false;
                }
            },
        },

        mounted(){

            //清空定时器
            if(this.recomT){clearTimeout(this.recomT)}

            setTimeout(()=>{

                this.recom = this.$store.state.RecommendData.publicFormat;

                let $carFloor = JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.map).floorType.stopcar,
                isCarPark = $carFloor.some((item)=>{return item == $VAR.map.currentMapInfo.floorID});

                //初次显示弹框
                if(!this.$mapStep.type && !isCarPark){

                    let showRecommed = this.$mapStore.plugInfo.buildingId + 'showRcommed',
                        showed = window.localStorage.getItem(showRecommed);

                    if(!showed){
                        this.showTab = true;
                        window.localStorage.setItem(showRecommed,true);
                        this.recomT=  setTimeout(()=>{this.showTab = false;},6000);
                    }
                }

            },10)


            this.$nextTick(()=>{
                this.showTab = true;
            })

            // this.$request.get('json/facility_data.json').then(res => {
            //     this.recom = res.data;
            // });

        }

    }
</script>

<style lang="less">
    @import "RecommendModule.less";
</style>
